// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  baseUrl:'https://reporting.lqs.co.in/fms/api/v1/common/',
  imageUrl:'https://reporting.lqs.co.in/',
  masterUrl: 'https://reporting.lqs.co.in/fms/api/v1/master/',
  production: true,
  callDistributionDeployDate: '2026-02-28' // deploy date for call distribution report change 3 hourly into 2 hourly logic leads creation and attending graphs
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
